var search_suggestions = [
	"Acorn Bag",
	"Afternoon Dress",
	"Apple Basket",
	"Atlas Beni Wool Rug",
	"Backpack",
	"Basket",
	"Basque Basket",
	"Bayu Rattan Changing Basket",
	"Bedding Set for Strolley",
	"Belle Button Down Dress",
	"Berry Basket",
	"Big Berry Basket",
	"Big Caro Seagrass Basket",
	"Big Luggy",
	"Birdie",
	"Blouse",
	"Bodysuit",
	"Bolga",
	"Bowery Basket",
	"Cabouche Basket",
	"Cardigan for Doll",
	"Care Set",
	"Casa Bag",
	"Casa Cluth",
	"Cassia Dress",
	"Chalk",
	"Changing Basket",
	"Changing Basket Liner",
	"Clothes Rail for Doll",
	"Cozy Dinkums",
	"Cricket",
	"Dahlia Dress",
	"Daisy Dress for Doll",
	"Decor",
	"Dinkum Doll",
	"Dinosaurs",
	"Display Bowl",
	"Doll Basket",
	"Doll Bottle",
	"Doll Brush",
	"Doll Carrier",
	"Doll Clothing",
	"Doll Dress",
	"Doll Luggy",
	"Doll PJ’s",
	"Doll Romper",
	"Doll Shoes",
	"Doll Toaty Trunk",
	"Dollychari",
	"Dozy Dinkums",
	"Dream Dinkum Dolls",
	"Dress",
	"Ducky Romper for Doll",
	"Dusk Maxi Dress",
	"Dyla Nyla Changing Basket",
	"Egg Basket",
	"Essy Wool Rug",
	"Fairy",
	"Fern Shorts",
	"Fleur Blouse",
	"Flor Muu Muu Dress",
	"Flor Shift Dress",
	"Flora Wrap Dress",
	"Flourish Mini Muu",
	"Folk Fairy",
	"Forest Folk",
	"Freya Wrap",
	"Full Brief Underwares",
	"Garden Dress",
	"Gift Card",
	"Hanging Book Basket",
	"Hanging Hutch",
	"Hello Hanging Shelf",
	"Hero Set",
	"High Chair for Doll",
	"Holdie Barn",
	"Holdie Folk",
	"Holdie Furniture",
	"Holdie House",
	"Hutch Big Basket",
	"Hutch Small Masket",
	"Insert",
	"Juno Dress",
	"Kaya Robe",
	"Kaya Wrap",
	"Knickers Full Brief",
	"Knit Set",
	"Laundry Basket",
	"Lilly Pilly Shirt",
	"Liner",
	"Luggy",
	"Luggy Cover",
	"Luvya Bag",
	"Luxe Liner",
	"Lyra",
	"Magical Creatures",
	"Make your own Felt Kit",
	"Mamachari",
	"Medium Luggy",
	"Mermaid",
	"Midi Bolga",
	"Mini Dozy Dinkum",
	"Mini Chari",
	"Moppet Dozy Dinkum",
	"Moses basket",
	"Mosey Basket",
	"Mushroom Basket",
	"Mushroom rattle",
	"Natura Wool Rug",
	"Natural",
	"Nora Pants",
	"Nursery",
	"Nyla Changing Basket",
	"Onion Basket",
	"Pants",
	"Peanut Dinkum Doll",
	"Petite Bolga",
	"Pickle Dozy Dinkum",
	"Piki",
	"Piki Basket",
	"Pip Dozy Dinkum",
	"PJ’s for Doll",
	"Play’n Pack",
	"PlayPa",
	"Playpa paper",
	"Playpa Stickers",
	"Poppet Dinkum Doll",
	"Pretend Pack",
	"Pumpkin Dinkum Doll",
	"Raffia Biz Bag",
	"Raincoat for Doll",
	"Rattan",
	"Rattle",
	"Raya Rattle",
	"Reva Changing Basket",
	"Robbie",
	"Rolo Romper Set for Doll",
	"Romper for Doll",
	"Roo Dinkum Doll",
	"Rose",
	"Rug",
	"Saloon Blouse",
	"Satch Backpack",
	"Seagrass",
	"See-ya Suitcase",
	"Shell Bag",
	"Shoes for Doll",
	"Shorts",
	"Sienna Maxi Dress",
	"Snuggly Set",
	"Soolip Dress",
	"Soukie Backpack",
	"Sparkle Set",
	"Sprout Dinkum Doll",
	"Stickers",
	"Stool",
	"Storage Basket",
	"Storie Stool",
	"Straw",
	"Strolley",
	"Strolley Bedding Set",
	"Strolley Handle",
	"Strolley Mattress",
	"Suitcase",
	"Suki Semi Wrap Dress",
	"Sundress",
	"Taking care of Biz Bag",
	"Tarry",
	"Tinky Basket Set",
	"Tiny Dinkum Doll",
	"Toaty Trunk",
	"Totty Display Bowl",
	"Toulouse Jumpsuit",
	"Travel Togs",
	"Trinka Basket Set",
	"Tuscan",
	"Una Rainbow Dress for Doll",
	"Underwares",
	"Vintage Blue",
	"Wagon",
	"Wonder Wagon"
];


function autocomplete(inp, arr) {
	/*the autocomplete function takes two arguments,
	the text field element and an array of possible autocompleted values:*/
	var currentFocus;
	var suggestionResults;
	/*execute a function when someone writes in the text field:*/
	inp.addEventListener("input", function(e) {
		var a, b, i, val = this.value;
		/*close any already open lists of autocompleted values*/
		closeAllLists();
		if (!val) { return false;}
		currentFocus = -1;
		suggestionResults = 0;
		/*create a DIV element that will contain the items (values):*/
		a = document.createElement("DIV");
		a.setAttribute("id", this.id + "autocomplete-list");
		a.setAttribute("class", "autocomplete-items");
		/*append the DIV element as a child of the autocomplete container:*/
		this.parentNode.appendChild(a);
		/*for each item in the array...*/
		for (i = 0; i < arr.length; i++) {
			/*check if the item starts with the same letters as the text field value:*/
			if (suggestionResults < 3) {
				if (arr[i].substr(0, val.length).toUpperCase() == val.toUpperCase()) {
					/*create a DIV element for each matching element:*/
					b = document.createElement("DIV");
					suggestionResults += 1				

					/*make the matching letters bold:*/
					b.innerHTML = "<strong>" + arr[i].substr(0, val.length) + "</strong>";
					b.innerHTML += arr[i].substr(val.length);
					/*insert a input field that will hold the current array item's value:*/
					b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
					/*execute a function when someone clicks on the item value (DIV element):*/
					b.addEventListener("click", function(e) {
						/*insert the value for the autocomplete text field:*/
						inp.value = this.getElementsByTagName("input")[0].value;
						/*close the list of autocompleted values,
						(or any other open lists of autocompleted values:*/
					
						$(inp).trigger('change')
					
						closeAllLists();
					});
					a.appendChild(b);
				}
			}
		}
	});
	/*execute a function presses a key on the keyboard:*/
	inp.addEventListener("keydown", function(e) {
		var x = document.getElementById(this.id + "autocomplete-list");
		if (x) x = x.getElementsByTagName("div");
		if (e.keyCode == 40) {
			/*If the arrow DOWN key is pressed,
			increase the currentFocus variable:*/
			currentFocus++;
			/*and and make the current item more visible:*/
			addActive(x);
		} else if (e.keyCode == 38) { //up
			/*If the arrow UP key is pressed,
			decrease the currentFocus variable:*/
			currentFocus--;
			/*and and make the current item more visible:*/
			addActive(x);
		} else if (e.keyCode == 13) {
			/*If the ENTER key is pressed, prevent the form from being submitted,*/
			e.preventDefault();
			if (currentFocus > -1) {
				/*and simulate a click on the "active" item:*/
				if (x) x[currentFocus].click();
			}
		}
	});
	function addActive(x) {
		/*a function to classify an item as "active":*/
		if (!x) return false;
		/*start by removing the "active" class on all items:*/
		removeActive(x);
		if (currentFocus >= x.length) currentFocus = 0;
		if (currentFocus < 0) currentFocus = (x.length - 1);
		/*add class "autocomplete-active":*/
		x[currentFocus].classList.add("autocomplete-active");
	}
	function removeActive(x) {
		/*a function to remove the "active" class from all autocomplete items:*/
		for (var i = 0; i < x.length; i++) {
			x[i].classList.remove("autocomplete-active");
		}
	}
	function closeAllLists(elmnt) {
		/*close all autocomplete lists in the document,
		except the one passed as an argument:*/
		var x = document.getElementsByClassName("autocomplete-items");
		for (var i = 0; i < x.length; i++) {
			if (elmnt != x[i] && elmnt != inp) {
				x[i].parentNode.removeChild(x[i]);
			}
		}
	}
	/*execute a function when someone clicks in the document:*/
	document.addEventListener("click", function (e) {
		closeAllLists(e.target);
	});
}

autocomplete(document.getElementById('autocomplete-search'), search_suggestions);
